export { ProductDetailsSectionTitle } from './ProductDetailsSectionTitle';
